<template>
  <modal v-if="isShow" @close="$emit('update:isShow', false)">
    <template slot="header">      
      <md-button class="md-info md-sm" @click="exportToPDF">PDF로 저장</md-button>
      <!-- <md-button class="md-success md-sm" @click="exportToExcel" style="margin-left: 5px;">엑셀로 저장</md-button>
      <md-button class="md-success md-sm" @click="exportToExcelWithImage" style="margin-left: 5px;">엑셀로 저장(이미지)</md-button> -->
      <md-button class="md-default md-sm" @click="$emit('update:isShow', false)" style="margin-left: 5px;">닫기</md-button>
    </template>
    <template slot="body">
        <div class="wrap" style="width: 595px; padding: 30px; background: #fff;" ref="pdfArea">
            <div style="background: #fff;" ref="upperSection">
                <div style="display: flex; align-items: center; justify-content: space-between;">
                    <div style="display: flex; align-items: center;">
                        <p style="width: 38px;"><img style="width: 100%;" src="/img/kuaa_logo_wh.png" alt=""></p>
                        <p style="margin-left: 10px; font-size: 18px; font-weight: 700;">고대교우회/(재)고우장학회 장학금 기부자 이력카드</p>
                    </div>


                    <!-- <ul style="border: 1px solid #000; width: 204px;">
                        <li style="display: flex; height: 20px;">
                            <p style="font-weight: 500; width: 35px; display: flex; justify-content: center; align-items: center;">구분</p>

                            <div style="display: flex; align-items: center; gap: 4px; border-left: 0.75px solid #000; padding-left: 6px;">
                                <input type="checkbox" checked="checked" id="gubun1" style="width: 10px; height: 10px; border: 0.5px solid #000; margin: 1px 0 0; padding: 0;">
                                <label for="gubun1">교우</label>

                                <input type="checkbox" id="gubun2" style="width: 10px; height: 10px; border: 0.5px solid #000; margin: 1px 0 0; padding: 0; margin-left: 2px;">
                                <label for="gubun2">단체</label>

                                <input type="checkbox" id="gubun3" style="width: 10px; height: 10px; border: 0.5px solid #000; margin: 1px 0 0; padding: 0; margin-left: 2px;">
                                <label for="gubun3">기본재산</label>

                                <input type="checkbox" id="gubun4" style="width: 10px; height: 10px; border: 0.5px solid #000; margin: 1px 0 0; padding: 0; margin-left: 2px;">
                                <label for="gubun4">기부금</label>
                            </div>
                        </li>

                        <li style="display: flex; height: 20px; border-top: 0.5px solid #000; background: #FFE6EA;">
                            <p style="font-weight: 500; width: 35px; display: flex; justify-content: center; align-items: center;">기부자</p>

                            <div style="display: flex; align-items: center; border-left: 0.75px solid #000; padding-left: 6px;">{{ printData.memberHnm }}</div>
                        </li>

                        <li style="display: flex; height: 20px; border-top: 0.5px solid #000;">
                            <p style="font-weight: 500; width: 35px; display: flex; justify-content: center; align-items: center;">작성자</p>

                            <div style="display: flex; align-items: center; border-left: 0.75px solid #000; padding-left: 6px;">이상미</div>
                        </li>

                        <li style="display: flex; height: 20px; border-top: 0.5px solid #000;">
                            <p style="font-weight: 500; width: 35px; display: flex; justify-content: center; align-items: center;">출력일</p>

                            <div style="display: flex; align-items: center; border-left: 0.75px solid #000; padding-left: 6px;">{{ new Date().toLocaleDateString() }}</div>
                        </li>
                    </ul> -->
                </div>


                <p style="font-size: 10px; font-weight: 700; margin-bottom: 4px;">기부자 기본 정보</p>
                <div style="border: 1px solid #000; display: flex;">
                    <ul style="background: #e0e0e0; width: 56px; font-weight: 600;">
                        <li style="height: 20px; display: flex; justify-content:center; align-items: center;">성명(단체명)</li>
                        <li style="height: 20px; display: flex; justify-content:center; align-items: center; border-top: 0.75px solid #000;">생년월일</li>
                        <li style="height: 20px; display: flex; justify-content:center; align-items: center; border-top: 0.75px solid #000;">직장명</li>
                        <li style="height: 20px; display: flex; justify-content:center; align-items: center; border-top: 0.75px solid #000;">기탁개시일</li>
                        <li style="height: 20px; display: flex; justify-content:center; align-items: center; border-top: 0.75px solid #000;">장학담당자</li>
                        <li style="height: 20px; display: flex; justify-content:center; align-items: center; border-top: 0.75px solid #000;">발송조건</li>
                        <li style="height: 20px; display: flex; justify-content:center; align-items: center; border-top: 0.75px solid #000;">우편물 주소</li>
                    </ul>


                    <ul style="width: 365px; border-left: 0.5px solid #000;">
                        <li style="height: 20px; display: flex;">
                            <p style="width: 75px; display: flex; padding-left: 6px; align-items: center;">
                              {{ printData.memberHnm ? printData.memberHnm : '-' }}</p>
                            <p style="width: 56px; display: flex; align-items: center; justify-content: center; background: #e0e0e0; border-left: 0.5px solid #000; font-weight: 600;">학과</p>
                            <p style="width: 75px; display: flex; padding-left: 6px; align-items: center; border-left: 0.5px solid #000;">{{printData.classNm ? printData.classNm : '-'}}</p>
                            <p style="width: 56px; display: flex; align-items: center; justify-content: center; background: #e0e0e0; border-left: 0.5px solid #000; font-weight: 600;">학번</p>
                            <p style="flex: 1 1 auto; display: flex; padding-left: 6px; align-items: center; border-left: 0.5px solid #000;">{{printData.hakbun ? printData.hakbun : '-'}}</p>
                        </li>

                        <li style="height: 20px; display: flex; border-top: 0.75px solid #000;">
                            <p style="width: 75px; display: flex; padding-left: 6px; align-items: center;">
                              {{ printData.memberInfo.birthday ? getDateFormat(printData.memberInfo.birthday) : '-' }}
                            </p>
                            <p style="width: 56px; display: flex; align-items: center; justify-content: center; background: #e0e0e0; border-left: 0.5px solid #000; font-weight: 600;">연락처</p>
                            <p style="width: 75px; display: flex; padding-left: 6px; align-items: center; border-left: 0.5px solid #000;">{{ printData.cellular ? printData.cellular : '-' }}</p>
                            <p style="width: 56px; display: flex; align-items: center; justify-content: center; background: #e0e0e0; border-left: 0.5px solid #000; font-weight: 600;">이메일</p>
                            <p style="flex: 1 1 auto; display: flex; padding-left: 6px; align-items: center; border-left: 0.5px solid #000;">{{ printData.memberInfo.eMail ? printData.memberInfo.eMail : '-' }}</p>
                        </li>

                        <li style="height: 20px; display: flex; border-top: 0.75px solid #000;">
                            <p style="width: 75px; display: flex; padding-left: 6px; align-items: center;"> {{ printData.companyNm ? printData.companyNm : '-' }}</p>
                            <p style="width: 56px; display: flex; align-items: center; justify-content: center; background: #e0e0e0; border-left: 0.5px solid #000; font-weight: 600;">직위</p>
                            <p style="width: 75px; display: flex; padding-left: 6px; align-items: center; border-left: 0.5px solid #000;">{{printData.memberorgGbNm ? printData.memberorgGbNm : '-'}}</p>
                            <p style="width: 56px; display: flex; align-items: center; justify-content: center; background: #e0e0e0; border-left: 0.5px solid #000; font-weight: 600;">기부일</p>
                            <p style="flex: 1 1 auto; display: flex; padding-left: 6px; align-items: center; border-left: 0.5px solid #000;">
                              {{
                                printData.depositDate && printData.depositDate.length === 8
                                  ? printData.depositDate.substr(0,4) + '.' + printData.depositDate.substr(4,2) + '.' + printData.depositDate.substr(6,2)
                                  : (printData.depositDate ? printData.depositDate : '-')
                              }}
                            </p>
                        </li>

                        <li style="height: 20px; display: flex; border-top: 0.75px solid #000;">
                            <p style="width: 75px; display: flex; padding-left: 6px; align-items: center;">
                              {{
                                printData.donateStartDate && printData.donateStartDate.length === 8
                                  ? printData.donateStartDate.substr(0,4) + '.' + printData.donateStartDate.substr(4,2) + '.' + printData.donateStartDate.substr(6,2)
                                  : (printData.donateStartDate ? printData.donateStartDate : '-')
                              }}
                            </p>
                            <p style="width: 56px; display: flex; align-items: center; justify-content: center; background: #e0e0e0; border-left: 0.5px solid #000; font-weight: 600;">기본재산편입일</p>
                            <p style="width: 75px; display: flex; padding-left: 6px; align-items: center; border-left: 0.5px solid #000;">
                              {{
                                printData.baseStartDate && printData.baseStartDate.length === 8
                                  ? printData.baseStartDate.substr(0,4) + '.' + printData.baseStartDate.substr(4,2) + '.' + printData.baseStartDate.substr(6,2)
                                  : (printData.baseStartDate ? printData.baseStartDate : '-')
                              }}
                            </p>
                            <p style="width: 56px; display: flex; align-items: center; justify-content: center; background: #e0e0e0; border-left: 0.5px solid #000; font-weight: 600;">기부액</p>
                            <p style="flex: 1 1 auto; display: flex; padding-left: 6px; align-items: center; border-left: 0.5px solid #000; gap: 10px;"><span> {{ formatGuja(printData.giveAmount) }}</span>{{printData.giveAmount.toLocaleString()}}원</p>
                        </li>

                        <li style="height: 20px; display: flex; border-top: 0.75px solid #000;">
                            <p style="width: 75px; display: flex; padding-left: 6px; align-items: center;">{{ printData.managerNm ? printData.managerNm : '-' }}</p>
                            <p style="width: 56px; display: flex; align-items: center; justify-content: center; background: #e0e0e0; border-left: 0.5px solid #000; font-weight: 600;">담당자 핸드폰</p>
                            <p style="width: 75px; display: flex; padding-left: 6px; align-items: center; border-left: 0.5px solid #000;">{{ printData.celluar ? printData.celluar : '-' }}</p>
                            <p style="width: 56px; display: flex; align-items: center; justify-content: center; background: #e0e0e0; border-left: 0.5px solid #000; font-weight: 600;">담당자 이메일</p>
                            <p style="flex: 1 1 auto; display: flex; padding-left: 6px; align-items: center; border-left: 0.5px solid #000;">{{ printData.eMail ? printData.eMail : '-' }}</p>
                        </li>

                        <li style="height: 20px; display: flex; border-top: 0.75px solid #000;">
                            <p style="width: 75px; display: flex; padding-left: 6px; align-items: center;">
                              <span v-if="printData.sendCondition === '1'">e-mail</span>
                              <span v-else-if="printData.sendCondition === '2'">FAX</span>
                              <span v-else-if="printData.sendCondition === '3'">기타</span>
                              <span v-else>-</span>
                            </p>
                            <p style="width: 56px; display: flex; align-items: center; justify-content: center; background: #e0e0e0; border-left: 0.5px solid #000; font-weight: 600;">지급형태</p>
                            <p style="width: 75px; display: flex; padding-left: 6px; align-items: center; border-left: 0.5px solid #000;">
                                <!-- <input type="checkbox" id="chk2_1" style="width: 10px; height: 10px; border: 0.5px solid #000; margin: 1px 0 0; padding: 0;">
                                <label for="chk2_1">개인</label>

                                <input type="checkbox" id="chk2_2" style="width: 10px; height: 10px; border: 0.5px solid #000; margin: 1px 0 0; padding: 0; margin-left: 6px;">
                                <label for="chk2_2">재단</label>

                                <input type="checkbox" id="chk2_3" style="width: 10px; height: 10px; border: 0.5px solid #000; margin: 1px 0 0; padding: 0; margin-left: 6px;">
                                <label for="chk2_3">기타</label> -->
                                <span v-if="printData.giveGb === '1'">교우</span>
                                <span v-else-if="printData.giveGb === '2'">비교우</span>
                                <span v-else-if="printData.giveGb === '3'">단체</span>
                                <span v-else> - </span>
                            </p>
                            <!-- <p style="width: 56px; display: flex; align-items: center; justify-content: center; background: #e0e0e0; border-left: 0.5px solid #000; font-weight: 500;">지급기준</p>
                            <p style="flex: 1 1 auto; display: flex; padding-left: 6px; align-items: center; border-left: 0.5px solid #000;"> -->
                                <!-- <input type="checkbox" :checked="printData.designateGb === 'Y'" id="chk3_1" style="width: 10px; height: 10px; border: 0.5px solid #000; margin: 1px 0 0; padding: 0;" disabled>
                              <label for="chk3_1">본인지정</label>

                              <input type="checkbox" :checked="printData.designateGb === 'N'" id="chk3_2" style="width: 10px; height: 10px; border: 0.5px solid #000; margin: 1px 0 0; padding: 0; margin-left: 6px;" disabled>
                              <label for="chk3_2">교우회 일임</label> -->
                              <!-- <span v-if="printData.designateGb === 'Y'">본인지정</span>
                              <span v-else-if="printData.designateGb === 'N'">교우회 일임</span>
                              <span v-else>-</span>                               -->                              
                              <!-- {{ printData.conditionEtc ? printData.conditionEtc : '-' }}
                            </p> -->
                        </li>

                        <li style="height: 20px; display: flex; border-top: 0.75px solid #000; align-items: center; padding-left: 6px;">
                            {{ printData.agreemAddress1 ? printData.agreemAddress1 + ' ' : '-' }} {{ printData.agreemAddress2 ? printData.agreemAddress2 : '' }}
                        </li>
                    </ul>


                    <div style="flex: 1 1 auto; border-left: 0.75px solid #000; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 10px; background: #e0e0e0;">
                        <img v-if="savedImgUrl" :src="savedImgUrl" alt="" style="max-width: 105px; max-height: 100%; width: auto; height: auto; object-fit: contain; display: block;" @error="handleImageError">
                        <span v-else style="font-size: 8px; color: #999;">이미지 없음</span>
                    </div>
                </div>



                <p style="font-size: 10px; font-weight: 700; margin: 20px 0 4px;">장학금 지급 내역</p>
                <div ref="donationHistorySection" style="border: 1px solid #000; display: flex; background: #fff;">
                    <ul
    v-for="(year, idx) in yearsAsc"
    :key="year"
    :style="`width: 88px;${idx !== 0 ? 'border-left: 0.75px solid #000;' : ''}`"
  >
    <li style="height: 20px; background: #e0e0e0; display: flex; justify-content: center; align-items: center; font-weight: 600;">
      {{ year }}년
    </li>
    <li style="height: 20px; border-top: 0.5px solid #000; font-weight: 600; display: flex; background: #e0e0e0;">
      <p style="display: flex; justify-content: center; align-items: center; font-weight: 600; flex: 1 1 50%;">1학기</p>
      <p style="display: flex; justify-content: center; align-items: center; font-weight: 600; flex: 1 1 50%; border-left: 0.5px solid #000;">2학기</p>
    </li>
    <li style="height: 20px; border-top: 0.75px solid #000; display: flex;">
      <p style="display: flex; justify-content: center; align-items: center; font-size: 6px; flex: 1 1 25%">
        {{ getAgreeAmountBySemesterCd(year + '01') ? formatGuja(getAgreeAmountBySemesterCd(year + '01')): '' }}
      </p>
      <p style="display: flex; justify-content: center; align-items: center; font-size: 6px; flex: 1 1 25%; border-left: 0.5px solid #000;">
        <span v-if="getStCountBySemesterCd(year + '01')" style="font-size: 6px;">{{ getStCountBySemesterCd(year + '01') }}명</span>
      </p>
      <p style="display: flex; justify-content: center; align-items: center; font-size: 6px; flex: 1 1 25%; border-left: 0.5px solid #000;">
        {{ getAgreeAmountBySemesterCd(year + '02') ? formatGuja(getAgreeAmountBySemesterCd(year + '02')) : '' }}
      </p>
      <p style="display: flex; justify-content: center; align-items: center; font-size: 6px; flex: 1 1 25%; border-left: 0.5px solid #000;">
        <span v-if="getStCountBySemesterCd(year + '02')" style="font-size: 6px;">{{ getStCountBySemesterCd(year + '02') }}명</span>
      </p>
    </li>
    <li style="height: 20px; border-top: 0.5px solid #000; display: flex;">
      <p style="flex: 1 1 50%; display: flex; justify-content: right; padding-right: 2px; align-items: center; font-size: 6px;">
        <span v-if="getAgreeAmountBySemesterCd(year + '01')" style="font-size: 6px;">{{ getAgreeAmountBySemesterCd(year + '01').toLocaleString() }}원</span>
      </p>
      <p style="flex: 1 1 50%; display: flex; justify-content: right; padding-right: 2px; align-items: center; font-size: 6px; border-left: 0.5px solid #000;">
        <span v-if="getAgreeAmountBySemesterCd(year + '02')" style="font-size: 6px;">{{ getAgreeAmountBySemesterCd(year + '02').toLocaleString() }}원</span>
      </p>
    </li>
  </ul>

                    <ul style="flex: 1 1 auto; border-left: 0.75px solid #000;">
                        <li style="height: 40px; background: #e0e0e0; display: flex; justify-content: center; align-items: center; font-weight: 600; font-size: 10px;">총액</li>

                        <li style="height: 20px; border-top: 0.75px solid #000; display: flex;">
                            <p style="display: flex; justify-content: center; align-items: center; flex: 1 1 50%">{{ formatGuja(totalAllAmount) }}</p>
                            <p style="display: flex; justify-content: center; align-items: center; flex: 1 1 50%; border-left: 0.5px solid #000;">{{ totalAllStCount }}명</p>
                        </li>

                        <li style="height: 20px; border-top: 0.5px solid #000; display: flex; justify-content: center; align-items: center; font-weight: 500;">{{ totalAllAmount.toLocaleString() }}원</li>
                    </ul>
                </div>



                <p style="font-size: 10px; font-weight: 700; margin: 20px 0 4px;">기탁계기 및 참고 사항</p>
                <ul style="border: 1px solid #000;">
                    <li style="display: flex; height: 20px;">
                        <p style="width: 50px; background: #e0e0e0; font-weight: 600; display: flex; flex: 0 0 auto; justify-content: center; align-items: center;">기탁계기</p>
                        <div style="display: flex; align-items: center; padding-left: 6px; border-left: 0.75px solid #000;">
                          {{ printData.donateMotive ? printData.donateMotive : '-' }}
                        </div>
                    </li>

                    <li style="display: flex; height: 20px; border-top: 0.75px solid #000;">
                        <p style="width: 50px; background: #e0e0e0; font-weight: 600; display: flex;  flex: 0 0 auto; justify-content: center; align-items: center;">선발조건</p>
                        <div style="display: flex; align-items: center; padding-left: 6px; border-left: 0.75px solid #000;">
                          {{ printData.conditionGive ? printData.conditionGive : '-' }}
                        </div>
                    </li>

                    <li style="display: flex; height: 20px; border-top: 0.75px solid #000;">
                        <p style="width: 50px; background: #e0e0e0; font-weight: 600; display: flex;  flex: 0 0 auto; justify-content: center; align-items: center;">지급기준</p>
                        <div style="display: flex; align-items: center; padding-left: 6px; border-left: 0.75px solid #000;">                          
                              <!-- <span v-if="printData.designateGb === 'Y'">본인지정</span>
                              <span v-else-if="printData.designateGb === 'N'">교우회 일임</span>
                              <span v-else>-</span>                    -->
                              {{ printData.conditionEtc ? printData.conditionEtc : '-' }}
                        </div>
                    </li>

                    <li style="display: flex; height: 20px; border-top: 0.75px solid #000;">
                        <p style="width: 50px; background: #e0e0e0; font-weight: 600; display: flex;  flex: 0 0 auto; justify-content: center; align-items: center;">주의사항</p>
                        <div style="display: flex; align-items: center; padding-left: 6px; border-left: 0.75px solid #000;">
                          {{ printData.etc ? printData.etc : '-' }}
                        </div>
                    </li>

                    <li style="display: flex; border-top: 0.75px solid #000;">
                        <p style="width: 50px; background: #e0e0e0; font-weight: 600; display: flex;  flex: 0 0 auto; justify-content: center; align-items: center;">비고</p>
                        <div style="border-left: 0.75px solid #000; flex: 1 1 auto;">
                            <p style="height: 20px; display: flex; align-items: center; padding-left: 6px;">
                              {{ printData.recomEtc ? printData.recomEtc : '-' }}
                            </p>
                        </div>
                    </li>
                </ul>
            </div>

                <p style="font-size: 10px; font-weight: 700; margin: 20px 0 4px;">주요 변동 사항</p>
                <!-- <ul style="border: 1px solid #000;"> -->
                <ul ref="contactHistorySection">
                  <li style="height: 20px; background: #e0e0e0; display: flex; font-weight: 600; border-top: 1px solid #000; border-bottom: 1px solid #000;">
                    <p style="flex: 0 0 auto; display: flex; align-items: center; justify-content: center; width: 88px; border-left: 1px solid #000;">연락자</p>
                    <p style="flex: 0 0 auto; display: flex; align-items: center; justify-content: center; width: 62px; border-left: 1px solid #000;">일자</p>
                    <p style="display: flex; align-items: center; justify-content: center; flex: 1 1 auto; border-left: 1px solid #000; border-right: 1px solid #000;">내용</p>
                  </li>
                  <li
                    v-for="(item, idx) in contactHistory"
                    :key="idx"
                    style="min-height: 20px; display: flex; flex-direction: column; padding: 0; border-bottom: 1px solid #000;"
                  >
                    <!-- 페이지 브레이크/헤더 조건부 출력 -->
                    <div v-if="shouldBreak(idx)">
                      <div style="page-break-before: always;"></div>                        
                      <div style="height: 20px; background: #e0e0e0; display: flex; font-weight: 600; border-top: 1px solid #000; border-bottom: 1px solid #000;">
                        <p style="flex: 0 0 auto; display: flex; align-items: center; justify-content: center; width: 88px; border-left: 1px solid #000;">연락자</p>
                        <p style="flex: 0 0 auto; display: flex; align-items: center; justify-content: center; width: 62px; border-left: 1px solid #000;">일자</p>
                        <p style="display: flex; align-items: center; justify-content: center; flex: 1 1 auto; border-left: 1px solid #000; border-right: 1px solid #000;">내용</p>
                      </div>
                    </div>
                    <div style="display: flex;">
                      <p style="flex: 0 0 auto; display: flex; align-items: center; justify-content: center; width: 88px; border-left: #000 1px solid;">
                        {{ item.contactPerson }}
                      </p>
                      <p style="flex: 0 0 auto; display: flex; align-items: center; justify-content: center; width: 62px; border-left: 1px solid #000;">
                        {{ item.contactDate.substr(0,4) }}.{{ item.contactDate.substr(4,2) }}.{{ item.contactDate.substr(6,2) }}
                      </p>
                      <p
                        style="padding: 5px 6px; flex: 1 1 auto; border-left: 1px solid #000; border-right: 1px solid #000; white-space: pre-line; text-align: left; padding-left: 1em;"
                      >
                        {{ item.contents }}
                        <!-- <span style="color: red; font-size: 10px;">          
                          [idx: {{ idx }}, sum: {{ getLineSum(idx) }}, break: {{ shouldBreak(idx) }}]
                        </span> -->
                      </p>
                    </div>
                  </li>
                </ul>
            </div><!-- inner div end -->
        </div><!-- .wrap end -->   

    </template>
    <template slot="footer">
    </template>
  </modal>
</template>

<script>
import html2pdf from 'html2pdf.js'
import html2canvas from 'html2canvas'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import URL_CONST from "@/kuaa/kuaa-url-const";
import Modal from "@/components/Modal.vue";
import kuaaApi from "@/kuaa/kuaa-api";
import { get } from 'jquery';
import kuaaFnc from '@/kuaa/kuaa-comm-func';
import formatter from "@/kuaa/kuaa-formatter";


export default {
  name: "PrintableDonator",

  components: {
    Modal,
  },

  props: {
    isShow: {
      type: Boolean,
      default: false
    },
  printData: {
    type: Object,
    default: () => ({})
  }
  },

  created(){
  },

  data() {
    return {
    donationHistory: [],
    donationHistoryAll: [],
    contactHistory: [],
    }
  },
  watch: {
    isShow(newVal) {
        if (
        newVal &&
        this.printData &&
        this.printData.memberNo
        ) {
        console.log('=== PrintableDonator 열림 ===');
        console.log('printData.photo:', this.printData.photo);
        console.log('savedImgUrl:', this.savedImgUrl);
        this.fetchDonationHistory();
        this.fetchContactHistory(); 
        }
    }
    },
    computed: {
        savedImgUrl() {
            if (this.printData && this.printData.photo) {
            let url = URL_CONST.FILE_DOWN_LOAD + "?fileBaseId=" + this.printData.photo;
            // 프로토콜이 없으면 http: 추가
            if (url.startsWith('//')) {
              url = 'http:' + url;
            }
            return url;
            }
            return null;
        },
    
        yearsAsc() {
          const now = new Date().getFullYear();
          // [2021, 2022, 2023, 2024, 2025] (예시)
          return Array.from({ length: 5 }, (_, i) => now - 4 + i);
        },
        totalAmount() {
          // yearsAsc의 각 연도 1,2학기 agreeAmount 합계
          return this.yearsAsc.reduce((sum, year) => {
            const amt1 = Number(this.getAgreeAmountBySemesterCd(year + '01')) || 0;
            const amt2 = Number(this.getAgreeAmountBySemesterCd(year + '02')) || 0;
            return sum + amt1 + amt2;
          }, 0);
        },
        totalStCount() {
          // yearsAsc의 각 연도 1,2학기 stCount 합계
          return this.yearsAsc.reduce((sum, year) => {
            const cnt1 = Number(this.getStCountBySemesterCd(year + '01')) || 0;
            const cnt2 = Number(this.getStCountBySemesterCd(year + '02')) || 0;
            return sum + cnt1 + cnt2;
          }, 0);
        },
        totalAllAmount() {
          // 전체 구간 agreeAmount 합계
          return this.donationHistoryAll.reduce((sum, item) => sum + (Number(item.agreeAmount) || 0), 0);
        },
        totalAllStCount() {
          // 전체 구간 stCount 합계
          return this.donationHistoryAll.reduce((sum, item) => sum + (Number(item.stCount) || 0), 0);
        }

    },
mounted() {

},

  methods: {  
    getLineSum(idx) {
      let sum = 0;
      for (let i = 0; i <= idx; i++) { // <=로 변경
        if (!this.contactHistory[i]) continue;
        const lines = (this.contactHistory[i].contents.match(/\n/g) || []).length + 1;
        sum += lines;
      }
      return sum;
    },
  // 페이지 브레이크 및 헤더 삽입 여부
    shouldBreak(idx) {
      if (idx === 0) return false;
      const prevSum = this.getLineSum(idx - 1); // idx 이전까지의 합
      const currSum = this.getLineSum(idx);     // idx까지의 합

      // 첫 번째 page-break: 19을 넘는 순간
      if (prevSum <= 19 && currSum > 19) return true;

      // 이후 page-break: 19 + 62 * n을 넘는 순간 (n=1,2,3,...)
      // 즉, prevSum <= 19 + 62 * n && currSum > 19 + 62 * n
      if (currSum > 19) {
        const n = Math.floor((prevSum - 19) / 62);
        const base = 19 + 62 * n;
        if (prevSum <= base && currSum > base) return true;
      }

      return false;
    },
  formatGuja: kuaaFnc.formatGuja,
  getDateFormat: formatter.getDateFormat,
    
  getAgreeAmountBySemesterCd(semesterCd) {
    const found = this.donationHistory.find(item => item.semesterCd === String(semesterCd));
    return found ? found.agreeAmount : '';
  },
  getStCountBySemesterCd(semesterCd) {
    const found = this.donationHistory.find(item => item.semesterCd === String(semesterCd));
    return found ? found.stCount : '';
    },
  fetchDonationHistory() {
  kuaaApi.sendServer(
      URL_CONST.GET_DONATION_LIST,
      { memberNo: this.printData.memberNo },
      "post",
      res => {
          // 실제 응답 구조 확인
          console.log("Donation API Response:", res);
        const allList = (res.data.data?.contents?.donationList || []);
        console.log("=== 받은 데이터 개수 ===", allList.length);
        console.log("=== 받은 데이터 ===", allList);

              // 년도별 분포 확인
        const years = allList.map(item => item.semesterCd?.substring(0, 4));
        console.log("=== 년도 목록 ===", [...new Set(years)].sort());
      
        this.donationHistoryAll = allList.map(item => ({
          year: item.semesterCd.substring(0, 4),
          semester: item.semesterCd.substring(4, 6),
          agreeAmount: item.agreemAmount,
          stCount: item.stCount,
          semesterCd: item.semesterCd
        }));
      
      console.log("=== donationHistoryAll ===", this.donationHistoryAll);
      console.log("=== totalAllStCount ===", this.totalAllStCount);
      console.log("=== totalAllAmount ===", this.totalAllAmount);
          const nowYear = new Date().getFullYear();
          const donationList = (res.data.data?.contents?.donationList || [])
              .filter(item => {
                  if (!item.semesterCd) return false;
                  const year = parseInt(item.semesterCd.substring(0, 4), 10);
                  return year >= nowYear - 4 && year <= nowYear;
              })
              .map(item => {
                  const year = item.semesterCd.substring(0, 4);
                  const semester = item.semesterCd.substring(4, 6);
                  return {
                      year,
                      semester,
                      agreeAmount: item.agreemAmount,
                      stCount: item.stCount,
                      semesterCd: item.semesterCd
                  };
              });
          this.donationHistory = donationList;
          

          console.log("donationHistory (last 5 years):", this.donationHistory);
      }
    );
},

fetchContactHistory() {
  kuaaApi.sendServer(
    URL_CONST.GET_DONOR_CONTACT_HISTORY,
    { memberNo: this.printData.memberNo },
    "post",
    res => {
      // 실제 응답 구조를 콘솔로 확인
      console.log("Contact History API Response:", res);

      // 예시: res.data.data.contents.contactHistoryList
      const contactList = (res.data.data?.contents || []).map(item => ({
        contactPerson: item.contactPerson,
        contactDate: item.contactDate,
        contents: item.contents
      }));
      this.contactHistory = contactList;
      console.log("contactHistory:", this.contactHistory);
    }
  );
},

    handleImageError(e) {
      console.error('이미지 로드 실패:', this.savedImgUrl);
      console.error('Image error event:', e);
    },

    async exportToPDF () {
      await html2pdf(this.$refs.pdfArea, {
        margin: [6, 5],
        filename: this.printData.semesterCdNm + '_' + this.printData.memberHnm + '_기부자카드.pdf',
        image: {type:"jpg", quality: 0.95},
        html2canvas: {useCORS: true, scrollY: 0, scale:3, dpi: 300, letterRendering: true, allowTaint: false},
        jsPDF: {orientation: 'portrait', unit: 'px', format: [630, 900], compressPDF: false}
      });
      // PDF 저장 후에만 데이터 초기화 및 모달 닫기
      this.printData = {};
      this.$emit('update:isShow', false);
    },

    async exportToExcel() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('기부자카드');
      
      // 기본 스타일 정의
      const headerStyle = {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFe0e0e0' } },
        font: { bold: true, size: 8 },
        alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
        border: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
      };
      
      const cellStyle = {
        font: { size: 8 },
        alignment: { vertical: 'middle', horizontal: 'left', wrapText: true },
        border: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
      };

      const pinkHeaderStyle = {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFE6EA' } },
        font: { bold: true, size: 9 },
        alignment: { vertical: 'middle', horizontal: 'center' },
        border: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
      };
      
      let currentRow = 1;
      
      // 열 너비 설정 (기본정보 6열 + 이미지 1열 = 7열)
      worksheet.getColumn(1).width = 16;
      worksheet.getColumn(2).width = 18;
      worksheet.getColumn(3).width = 16;
      worksheet.getColumn(4).width = 18;
      worksheet.getColumn(5).width = 16;
      worksheet.getColumn(6).width = 24;
      worksheet.getColumn(7).width = 18; // 이미지
      
      // 타이틀
      worksheet.mergeCells(`A${currentRow}:G${currentRow}`);
      const titleCell = worksheet.getCell(`A${currentRow}`);
      titleCell.value = '(재)고우장학회 장학금 기부자 이력카드';
      titleCell.font = { size: 13, bold: true };
      titleCell.alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getRow(currentRow).height = 25;
      currentRow += 2;
      
      // 기부자 기본 정보 섹션 타이틀
      worksheet.mergeCells(`A${currentRow}:G${currentRow}`);
      const infoTitleCell = worksheet.getCell(`A${currentRow}`);
      infoTitleCell.value = '기부자 기본 정보';
      infoTitleCell.font = { size: 10, bold: true };
      currentRow++;
      
      // 기본 정보 테이블
      // Row 1: 성명, 학과, 학번
      const basicInfoStartRow = currentRow; // 이미지 시작 위치 저장
      let row = worksheet.getRow(currentRow);
      row.getCell(1).value = '성명(단체명)';
      row.getCell(1).style = headerStyle;
      row.getCell(2).value = this.printData.memberHnm || '-';
      row.getCell(2).style = cellStyle;
      row.getCell(3).value = '학과';
      row.getCell(3).style = headerStyle;
      row.getCell(4).value = this.printData.classNm || '-';
      row.getCell(4).style = cellStyle;
      row.getCell(5).value = '학번';
      row.getCell(5).style = headerStyle;
      row.getCell(6).value = this.printData.hakbun || '-';
      row.getCell(6).style = cellStyle;
      row.height = 20;
      currentRow++;
      
      // Row 2: 생년월일, 연락처, 이메일
      row = worksheet.getRow(currentRow);
      row.getCell(1).value = '생년월일';
      row.getCell(1).style = headerStyle;
      row.getCell(2).value = this.getDateFormat(this.printData.memberInfo?.birthday) || '-';
      row.getCell(2).style = cellStyle;
      row.getCell(3).value = '연락처';
      row.getCell(3).style = headerStyle;
      row.getCell(4).value = this.printData.cellular || '-';
      row.getCell(4).style = cellStyle;
      row.getCell(5).value = '이메일';
      row.getCell(5).style = headerStyle;
      row.getCell(6).value = this.printData.memberInfo?.eMail || '-';
      row.getCell(6).style = cellStyle;
      row.height = 20;
      currentRow++;
      
      // Row 3: 직장명, 직위, 기부일
      row = worksheet.getRow(currentRow);
      row.getCell(1).value = '직장명';
      row.getCell(1).style = headerStyle;
      row.getCell(2).value = this.printData.companyNm || '-';
      row.getCell(2).style = cellStyle;
      row.getCell(3).value = '직위';
      row.getCell(3).style = headerStyle;
      row.getCell(4).value = this.printData.memberorgGbNm || '-';
      row.getCell(4).style = cellStyle;
      row.getCell(5).value = '기부일';
      row.getCell(5).style = headerStyle;
      row.getCell(6).value = this.printData.depositDate ? (this.printData.depositDate.length === 8 ? this.printData.depositDate.substr(0,4) + '.' + this.printData.depositDate.substr(4,2) + '.' + this.printData.depositDate.substr(6,2) : this.printData.depositDate) : '-';
      row.getCell(6).style = cellStyle;
      row.height = 20;
      currentRow++;
      
      // Row 4: 기탁개시일, 기본재산편입일, 기부액
      row = worksheet.getRow(currentRow);
      row.getCell(1).value = '기탁개시일';
      row.getCell(1).style = headerStyle;
      row.getCell(2).value = this.printData.donateStartDate || '-';
      row.getCell(2).style = cellStyle;
      row.getCell(3).value = '기본재산편입일';
      row.getCell(3).style = headerStyle;
      row.getCell(4).value = this.printData.baseStartDate || '-';
      row.getCell(4).style = cellStyle;
      row.getCell(5).value = '기부액';
      row.getCell(5).style = headerStyle;
      row.getCell(6).value = (this.printData.giveAmount ? this.formatGuja(this.printData.giveAmount) + this.getCurrency(this.printData.giveAmount) + '원' : '-');
      row.getCell(6).style = cellStyle;
      row.height = 20;
      currentRow++;
      
      // Row 5: 장학담당자, 담당자핸드폰, 담당자이메일
      row = worksheet.getRow(currentRow);
      row.getCell(1).value = '장학담당자';
      row.getCell(1).style = headerStyle;
      row.getCell(2).value = this.printData.managerNm || '-';
      row.getCell(2).style = cellStyle;
      row.getCell(3).value = '담당자핸드폰';
      row.getCell(3).style = headerStyle;
      row.getCell(4).value = this.printData.celluar || '-';
      row.getCell(4).style = cellStyle;
      row.getCell(5).value = '담당자이메일';
      row.getCell(5).style = headerStyle;
      row.getCell(6).value = this.printData.eMail || '-';
      row.getCell(6).style = cellStyle;
      row.height = 20;
      currentRow++;
      
      // Row 6: 발송조건, 지급형태
      row = worksheet.getRow(currentRow);
      row.getCell(1).value = '발송조건';
      row.getCell(1).style = headerStyle;
      worksheet.mergeCells(`B${currentRow}:C${currentRow}`);
      row.getCell(2).value = this.printData.sendCondition === '1' ? 'E-mail' : (this.printData.sendCondition === '2' ? 'FAX' : (this.printData.sendCondition === '3' ? '기타' : '-'));
      row.getCell(2).style = cellStyle;
      row.getCell(3).style = cellStyle;
      row.getCell(4).value = '지급형탌';
      row.getCell(4).style = headerStyle;
      worksheet.mergeCells(`E${currentRow}:F${currentRow}`);
      row.getCell(5).value = this.printData.giveGb === '1' ? '교우' : (this.printData.giveGb === '2' ? '비교우' : (this.printData.giveGb === '3' ? '단체' : '-'));
      row.getCell(5).style = cellStyle;
      row.getCell(6).style = cellStyle;
      row.height = 20;
      currentRow++;
      
      // 우편물 주소
      const addressRow = worksheet.getRow(currentRow);
      addressRow.getCell(1).value = '우편물 주소';
      addressRow.getCell(1).style = headerStyle;
      worksheet.mergeCells(`B${currentRow}:F${currentRow}`);
      addressRow.getCell(2).value = (this.printData.agreemAddress1 || '') + ' ' + (this.printData.agreemAddress2 || '');
      addressRow.getCell(2).style = cellStyle;
      addressRow.getCell(3).style = cellStyle;
      addressRow.getCell(4).style = cellStyle;
      addressRow.getCell(5).style = cellStyle;
      addressRow.getCell(6).style = cellStyle;
      const basicInfoEndRow = currentRow; // 이미지 끝 위치 저장
      addressRow.height = 20;
      currentRow += 2;
      
      // 장학금 지급 내역 타이틀
      worksheet.mergeCells(`A${currentRow}:G${currentRow}`);
      const donationTitleCell = worksheet.getCell(`A${currentRow}`);
      donationTitleCell.value = '장학금 지급 내역';
      donationTitleCell.font = { size: 10, bold: true };
      currentRow++;
      
      // 연도 헤더 행
      const yearRow = worksheet.getRow(currentRow);
      yearRow.getCell(1).value = '2021년';
      yearRow.getCell(1).style = headerStyle;
      yearRow.getCell(2).value = '2022년';
      yearRow.getCell(2).style = headerStyle;
      yearRow.getCell(3).value = '2023년';
      yearRow.getCell(3).style = headerStyle;
      yearRow.getCell(4).value = '2024년';
      yearRow.getCell(4).style = headerStyle;
      yearRow.getCell(5).value = '2025년';
      yearRow.getCell(5).style = headerStyle;
      yearRow.getCell(6).value = '총액';
      yearRow.getCell(6).style = { ...pinkHeaderStyle, fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFE6EA' } } };
      yearRow.height = 20;
      currentRow++;
      
      // 학기 헤더 행
      const semesterRow = worksheet.getRow(currentRow);
      for (let i = 1; i <= 5; i++) {
        semesterRow.getCell(i).value = '1학기          2학기';
        semesterRow.getCell(i).style = headerStyle;
      }
      semesterRow.getCell(6).value = '구좌/인원';
      semesterRow.getCell(6).style = headerStyle;
      semesterRow.height = 20;
      currentRow++;
      
      // 구좌/인원 행
      const dataRow1 = worksheet.getRow(currentRow);
      this.yearsAsc.forEach((year, idx) => {
        const amount1 = this.getAgreeAmountBySemesterCd(year + '01');
        const count1 = this.getStCountBySemesterCd(year + '01');
        const amount2 = this.getAgreeAmountBySemesterCd(year + '02');
        const count2 = this.getStCountBySemesterCd(year + '02');
        
        const text1 = (amount1 ? this.formatGuja(amount1) : '') + '  ' + (count1 ? count1 + '명' : '');
        const text2 = (amount2 ? this.formatGuja(amount2) : '') + '  ' + (count2 ? count2 + '명' : '');
        
        dataRow1.getCell(idx + 1).value = text1 + '     ' + text2;
        dataRow1.getCell(idx + 1).style = cellStyle;
        dataRow1.getCell(idx + 1).alignment = { vertical: 'middle', horizontal: 'center' };
      });
      dataRow1.getCell(6).value = this.formatGuja(this.totalAllAmount) + '  ' + this.totalAllStCount + '명';
      dataRow1.getCell(6).style = cellStyle;
      dataRow1.getCell(6).alignment = { vertical: 'middle', horizontal: 'center' };
      dataRow1.height = 20;
      currentRow++;
      
      // 금액 행
      const dataRow2 = worksheet.getRow(currentRow);
      this.yearsAsc.forEach((year, idx) => {
        const amount1 = this.getAgreeAmountBySemesterCd(year + '01');
        const amount2 = this.getAgreeAmountBySemesterCd(year + '02');
        
        const text1 = amount1 ? amount1.toLocaleString() + '원' : '';
        const text2 = amount2 ? amount2.toLocaleString() + '원' : '';
        
        dataRow2.getCell(idx + 1).value = text1 + '     ' + text2;
        dataRow2.getCell(idx + 1).style = cellStyle;
        dataRow2.getCell(idx + 1).alignment = { vertical: 'middle', horizontal: 'center' };
      });
      dataRow2.getCell(6).value = this.totalAllAmount.toLocaleString() + '원';
      dataRow2.getCell(6).style = { ...cellStyle, font: { size: 9, bold: true } };
      dataRow2.getCell(6).alignment = { vertical: 'middle', horizontal: 'center' };
      dataRow2.height = 20;
      currentRow += 2;
      
      // 기탁계기 및 참고 사항
      worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
      const motiveTitle = worksheet.getCell(`A${currentRow}`);
      motiveTitle.value = '기탁계기 및 참고 사항';
      motiveTitle.font = { size: 10, bold: true };
      motiveTitle.border = cellStyle.border;
      worksheet.getCell(`B${currentRow}`).border = cellStyle.border;
      worksheet.getCell(`C${currentRow}`).border = cellStyle.border;
      worksheet.getCell(`D${currentRow}`).border = cellStyle.border;
      worksheet.getCell(`E${currentRow}`).border = cellStyle.border;
      worksheet.getCell(`F${currentRow}`).border = cellStyle.border;
      currentRow++;
      
      // 기탁계기
      let motivRow = worksheet.getRow(currentRow);
      motivRow.getCell(1).value = '기탁계기';
      motivRow.getCell(1).style = headerStyle;
      worksheet.mergeCells(`B${currentRow}:F${currentRow}`);
      motivRow.getCell(2).value = this.printData.donateMotive || '-';
      motivRow.getCell(2).style = cellStyle;
      motivRow.getCell(3).style = cellStyle;
      motivRow.getCell(4).style = cellStyle;
      motivRow.getCell(5).style = cellStyle;
      motivRow.getCell(6).style = cellStyle;
      motivRow.height = 20;
      currentRow++;
      
      // 선발조건
      motivRow = worksheet.getRow(currentRow);
      motivRow.getCell(1).value = '선발조건';
      motivRow.getCell(1).style = headerStyle;
      worksheet.mergeCells(`B${currentRow}:F${currentRow}`);
      motivRow.getCell(2).value = this.printData.conditionGive || '-';
      motivRow.getCell(2).style = cellStyle;
      motivRow.getCell(3).style = cellStyle;
      motivRow.getCell(4).style = cellStyle;
      motivRow.getCell(5).style = cellStyle;
      motivRow.getCell(6).style = cellStyle;
      motivRow.height = 20;
      currentRow++;
      
      // 지급기준
      motivRow = worksheet.getRow(currentRow);
      motivRow.getCell(1).value = '지급기준';
      motivRow.getCell(1).style = headerStyle;
      worksheet.mergeCells(`B${currentRow}:F${currentRow}`);
      motivRow.getCell(2).value = this.printData.conditionEtc || '-';
      motivRow.getCell(2).style = cellStyle;
      motivRow.getCell(3).style = cellStyle;
      motivRow.getCell(4).style = cellStyle;
      motivRow.getCell(5).style = cellStyle;
      motivRow.getCell(6).style = cellStyle;
      motivRow.height = 20;
      currentRow++;
      
      // 주의사항
      motivRow = worksheet.getRow(currentRow);
      motivRow.getCell(1).value = '주의사항';
      motivRow.getCell(1).style = headerStyle;
      worksheet.mergeCells(`B${currentRow}:F${currentRow}`);
      motivRow.getCell(2).value = this.printData.etc || '-';
      motivRow.getCell(2).style = cellStyle;
      motivRow.getCell(3).style = cellStyle;
      motivRow.getCell(4).style = cellStyle;
      motivRow.getCell(5).style = cellStyle;
      motivRow.getCell(6).style = cellStyle;
      motivRow.height = 20;
      currentRow++;
      
      // 비고
      motivRow = worksheet.getRow(currentRow);
      motivRow.getCell(1).value = '비고';
      motivRow.getCell(1).style = headerStyle;
      worksheet.mergeCells(`B${currentRow}:F${currentRow}`);
      motivRow.getCell(2).value = this.printData.recomEtc || '-';
      motivRow.getCell(2).style = cellStyle;
      motivRow.getCell(3).style = cellStyle;
      motivRow.getCell(4).style = cellStyle;
      motivRow.getCell(5).style = cellStyle;
      motivRow.getCell(6).style = cellStyle;
      motivRow.height = 20;
      currentRow += 2;
      
      // 주요 변동 사항
      worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
      const contactTitleCell = worksheet.getCell(`A${currentRow}`);
      contactTitleCell.value = '주요 변동 사항';
      contactTitleCell.font = { size: 10, bold: true };
      contactTitleCell.border = cellStyle.border;
      worksheet.getCell(`B${currentRow}`).border = cellStyle.border;
      worksheet.getCell(`C${currentRow}`).border = cellStyle.border;
      worksheet.getCell(`D${currentRow}`).border = cellStyle.border;
      worksheet.getCell(`E${currentRow}`).border = cellStyle.border;
      worksheet.getCell(`F${currentRow}`).border = cellStyle.border;
      currentRow++;
      
      // 연락 히스토리 헤더
      const contactHeaderRow = worksheet.getRow(currentRow);
      contactHeaderRow.getCell(1).value = '연락자';
      contactHeaderRow.getCell(1).style = headerStyle;
      contactHeaderRow.getCell(2).value = '일자';
      contactHeaderRow.getCell(2).style = headerStyle;
      worksheet.mergeCells(`C${currentRow}:F${currentRow}`);
      contactHeaderRow.getCell(3).value = '내용';
      contactHeaderRow.getCell(3).style = headerStyle;
      contactHeaderRow.getCell(4).style = headerStyle;
      contactHeaderRow.getCell(5).style = headerStyle;
      contactHeaderRow.getCell(6).style = headerStyle;
      contactHeaderRow.height = 20;
      currentRow++;
      
      // 연락 히스토리 데이터
      this.contactHistory.forEach(item => {
        const row = worksheet.getRow(currentRow);
        row.getCell(1).value = item.contactPerson || '-';
        row.getCell(1).style = cellStyle;
        
        const date = item.contactDate ? item.contactDate.substr(0,4) + '.' + item.contactDate.substr(4,2) + '.' + item.contactDate.substr(6,2) : '-';
        row.getCell(2).value = date;
        row.getCell(2).style = cellStyle;
        row.getCell(2).alignment = { vertical: 'middle', horizontal: 'center' };
        
        worksheet.mergeCells(`C${currentRow}:F${currentRow}`);
        row.getCell(3).value = item.contents || '-';
        row.getCell(3).style = cellStyle;
        row.getCell(3).alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
        row.getCell(4).style = cellStyle;
        row.getCell(5).style = cellStyle;
        row.getCell(6).style = cellStyle;
        
        row.height = Math.max(30, (item.contents || '').split('\n').length * 15);
        currentRow++;
      });
      
      // 이미지 추가 (사진이 있는 경우)
      let imageId = null;
      if (this.savedImgUrl) {
        try {
          // 이미지를 ArrayBuffer로 가져오기 (원본 품질 유지)
          const response = await fetch(this.savedImgUrl);
          const blob = await response.blob();
          
          // Blob을 ArrayBuffer로 변환 (브라우저에서는 Buffer 대신 ArrayBuffer 사용)
          const arrayBuffer = await blob.arrayBuffer();
          
          // 이미지 타입 감지
          const imageType = blob.type.includes('png') ? 'png' : 'jpeg';
          
          imageId = workbook.addImage({
            buffer: arrayBuffer,
            extension: imageType
          });
          
          // 이미지를 기본정보 섹션 오른쪽(G열)에 배치
          // ExcelJS는 0-based 인덱스 사용: col 6 = G열, row는 0-based
          // editAs: 'absolute'로 설정하여 이미지가 잘리지 않도록 함
          worksheet.addImage(imageId, {
            tl: { col: 6, row: basicInfoStartRow - 1 },
            ext: { width: 110, height: (basicInfoEndRow - basicInfoStartRow + 1) * 20 },
            editAs: 'absolute'
          });
          
        } catch (error) {
          console.error('이미지 추가 실패:', error);
        }
      }
      
      // 파일 저장
      const buffer = await workbook.xlsx.writeBuffer();
      const fileName = (this.printData.semesterCdNm || '') + '_' + (this.printData.memberHnm || '기부자') + '_기부자카드.xlsx';
      saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), fileName);
    },

    async exportToExcelWithImage() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('기부자 이력카드');

      // 스타일 정의
      const headerStyle = {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFe0e0e0' } },
        font: { bold: true, size: 9 },
        alignment: { vertical: 'middle', horizontal: 'center' },
        border: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
      };

      const cellStyle = {
        font: { size: 9 },
        alignment: { vertical: 'middle', horizontal: 'left', wrapText: true },
        border: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
      };

      let currentRow = 1;

      // 열 너비 설정
      worksheet.getColumn(1).width = 18;
      worksheet.getColumn(2).width = 20;
      worksheet.getColumn(3).width = 60;

      // 상단 부분을 이미지로 캡처
      if (this.$refs.upperSection) {
        try {
          const canvas = await html2canvas(this.$refs.upperSection, {
            scale: 2,
            useCORS: true,
            backgroundColor: '#ffffff'
          });

          const imageData = canvas.toDataURL('image/png');
          const base64Data = imageData.split(',')[1];
          const binaryData = atob(base64Data);
          const arrayBuffer = new Uint8Array(binaryData.length);
          for (let i = 0; i < binaryData.length; i++) {
            arrayBuffer[i] = binaryData.charCodeAt(i);
          }

          const upperImageId = workbook.addImage({
            buffer: arrayBuffer,
            extension: 'png'
          });

          // 이미지 삽입 (비율 유지하며 적절한 크기로)
          worksheet.addImage(upperImageId, {
            tl: { col: 0, row: 0 },
            ext: { width: 595, height: canvas.height * (595 / canvas.width) },
            editAs: 'absolute'
          });

          // 이미지 높이에 따른 공간 확보 (동적 계산)
          const imageHeightInRows = Math.ceil((canvas.height * (595 / canvas.width)) / 20);
          for (let i = 0; i < imageHeightInRows; i++) {
            worksheet.getRow(currentRow).height = 20;
            currentRow++;
          }
        } catch (error) {
          console.error('상단 섹션 이미지 캡처 실패:', error);
        }
      }

      currentRow += 2;

      // 주요 변동 사항 타이틀
      worksheet.mergeCells(`A${currentRow}:C${currentRow}`);
      const contactTitleCell = worksheet.getCell(`A${currentRow}`);
      contactTitleCell.value = '주요 변동 사항';
      contactTitleCell.font = { size: 10, bold: true };
      contactTitleCell.border = cellStyle.border;
      worksheet.getCell(`B${currentRow}`).border = cellStyle.border;
      worksheet.getCell(`C${currentRow}`).border = cellStyle.border;
      currentRow++;

      // 연락 히스토리 헤더
      const contactHeaderRow = worksheet.getRow(currentRow);
      contactHeaderRow.getCell(1).value = '연락자';
      contactHeaderRow.getCell(1).style = headerStyle;
      contactHeaderRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
      contactHeaderRow.getCell(2).value = '일자';
      contactHeaderRow.getCell(2).style = headerStyle;
      contactHeaderRow.getCell(3).value = '내용';
      contactHeaderRow.getCell(3).style = headerStyle;
      contactHeaderRow.height = 20;
      currentRow++;

      // 연락 히스토리 데이터
      this.contactHistory.forEach(item => {
        const row = worksheet.getRow(currentRow);
        
        // 연락자 (가운데 정렬)
        const cell1 = row.getCell(1);
        cell1.value = item.contactPerson || '-';
        cell1.font = { size: 8 };
        cell1.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        cell1.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

        // 일자 (가운데 정렬)
        const date = item.contactDate ? item.contactDate.substr(0,4) + '.' + item.contactDate.substr(4,2) + '.' + item.contactDate.substr(6,2) : '-';
        const cell2 = row.getCell(2);
        cell2.value = date;
        cell2.font = { size: 8 };
        cell2.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        cell2.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

        // 내용 (좌측 정렬)
        const cell3 = row.getCell(3);
        cell3.value = item.contents || '-';
        cell3.font = { size: 8 };
        cell3.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        cell3.alignment = { vertical: 'top', horizontal: 'left', wrapText: true };

        row.height = Math.max(30, (item.contents || '').split('\n').length * 15);
        currentRow++;
      });

      // 파일 저장
      const buffer = await workbook.xlsx.writeBuffer();
      const fileName = (this.printData.semesterCdNm || '') + '_' + (this.printData.memberHnm || '기부자') + '_기부자카드_이미지.xlsx';
      saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), fileName);
    },

    getCurrency(num) {
      return num ? num.toString().replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,') : 0;
    },
    groupBy(list, keyGetter) {
      const map = new Map();
      list.forEach((item) => {
        const key = keyGetter(item);
        if (!map.has(key)) {
          map.set(key, [item]);
        } else {
          map.get(key).push(item);
        }
      });
      return map;
    }

  }
}
</script>

<style>
    .wrap * { margin: 0; padding: 0; list-style: none; font-family: "Noto Sans KR", sans-serif; color: #000; font-size: 8px; line-height: normal; }
</style>